<template>
	<div>
		<div class="mb-24 post-smtp-selector-wrapper">
			<post-smtp-days-selector
				v-on:days-selector-event="selectingDataFromDaysSelector"
				style="float: left"
				:post-smtp-configured="postSmtpConfigured"
			></post-smtp-days-selector>

			<a
				style="float:right;"
				class="re-launch-wizard"
				:href="admin_url + '?page=postman/configuration_wizard&action=add'"
				v-if="postSmtpConfigured || isMainWpConfigured"
			>
				<svg style="margin-bottom: -4px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 7.99998C12.7504 9.03089 12.3967 10.0307 11.7483 10.8321C11.0998 11.6335 10.1958 12.188 9.1875 12.4028C8.17921 12.6176 7.12773 12.4796 6.20895 12.012C5.29017 11.5444 4.5598 10.7755 4.14 9.83397L2.749 10.399C3.30042 11.6624 4.27003 12.6975 5.49482 13.3302C6.7196 13.9629 8.12488 14.1546 9.47438 13.8731C10.8239 13.5916 12.0353 12.8541 12.905 11.7845C13.7747 10.7149 14.2497 9.37852 14.25 7.99998C14.2501 6.74771 13.8583 5.5268 13.1296 4.50837C12.4009 3.48994 11.3719 2.72503 10.1866 2.32083C9.00138 1.91664 7.71937 1.89342 6.52027 2.25443C5.32117 2.61545 4.26508 3.3426 3.5 4.33398V2.49998H2V6.49998L2.75 7.24998H6.25V5.74998H4.352C4.84711 4.89165 5.61167 4.22073 6.52705 3.84134C7.44243 3.46196 8.45744 3.39531 9.41457 3.65174C10.3717 3.90818 11.2174 4.47336 11.8205 5.25958C12.4236 6.04579 12.7503 7.00909 12.75 7.99998Z" fill="#375CAF"/>
				</svg>
				{{ i18n.relaunch }}</a>
		</div>

		<post-smtp-banners
			class="mb-24"
			v-if="! postSmtpConfigured"
      :is-log-only-mode="isLogOnlyMode"
			:post-smtp-configured="postSmtpConfigured"
		></post-smtp-banners>

		<post-smtp-cards-container
			:period="period"
			class="mb-24"
			:post-smtp-configured="postSmtpConfigured"
			:post-smtp-pro="postSmtpPro"
		></post-smtp-cards-container>

		<post-smtp-banners
			class="mb-24"
			v-if="postSmtpConfigured"
			:post-smtp-configured="postSmtpConfigured"
      :is-log-only-mode="isLogOnlyMode"
		></post-smtp-banners>

		<post-smtp-logs-section
			class="mb-24"
			:post-smtp-configured="postSmtpConfigured"
		></post-smtp-logs-section>

		<post-smtp-pro-features
			v-if="! postSmtpPro"
			class="mb-24"
			:post-smtp-ad-position="postSmtpAdPosition"
		></post-smtp-pro-features>

		<post-smtp-guide class="mb-24"></post-smtp-guide>
	</div>
</template>

<script>
export default {
	name: 'PostSmtpDashboard',

	props: {
		postSmtpConfigured: {
			type: Boolean,
			default: false,
		},
		isMainWpConfigured : {
			type: Boolean,
			default: false,
		},
		postSmtpPro: {
			type: Boolean,
			default: false,
		},
		postSmtpAdPosition: {
			type: String,
			default: 'maximize',
		},

    isLogOnlyMode: {
      type: Boolean,
      default: false,
    },
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
		period: 'week',
   		i18n: postSmtpNewDashboard.i18n.dashboard,
	} ),

	methods: {
		selectingDataFromDaysSelector( period ) {
			this.period = period;
		}
	}
}
</script>

<style scoped>
.mb-24 {
	margin-bottom: 24px;
}

.post-smtp-selector-wrapper {
	position: relative;
}

.post-smtp-selector-wrapper a.re-launch-wizard {
	float: right;
	padding: 8px 16px;
	background: #f3f7ff;
	border: 1px solid #e2ebff;
	color: #375CAF;
	font-family: Poppins;
	font-size: 12px;
	font-weight: 600;
	line-height: 18px;
	text-align: left;
	text-decoration: none;
}

.post-smtp-selector-wrapper::after {
	content: '';
	clear: both;
	display: table;
}
</style>